// Resolves a route record into a human-readable destination label for the
// AppHeader breadcrumb.
// Pure helper: it only reads from Pinia stores, never mutates. Returning an
// empty string from `getRouteLabel` means "I don't have a good label for this
// route" — the caller falls back to a default.
import { useProjectsStore } from '@/stores/projects'
import type { PreviousRoute } from '@/stores/navigation'

// Native project names are shared by the overview, list, and customer summary.
export function projectDisplayName(projectId: number): string {
  const projects = useProjectsStore()
  const summary = projects.customerSummary[projectId]
  if (summary?.display_name) {
    return summary.display_name
  }
  const detail = projects.detail[projectId]
  if (detail) {
    return detail.name
  }
  const list = projects.projects.find((p) => p.id === projectId)
  if (list) {
    return list.name
  }
  return 'Project'
}

export function getRouteLabel(route: PreviousRoute): string {
  if (route.name.startsWith('project-')) {
    const id = Number(route.params.id)
    return Number.isFinite(id) ? projectDisplayName(id) : 'Project'
  }

  switch (route.name) {
    case 'projects':
      return 'Projects'
    case 'admin-users':
      return 'Admin · Users'
    case 'admin-security':
      return 'Admin · Security'
    case 'admin-integrations':
      return 'Admin · Integrations'
    default:
      return ''
  }
}
